import { render, staticRenderFns } from "./deal_xq.vue?vue&type=template&id=16a7c63d&scoped=true&"
import script from "./deal_xq.vue?vue&type=script&lang=js&"
export * from "./deal_xq.vue?vue&type=script&lang=js&"
import style0 from "./deal_xq.vue?vue&type=style&index=0&id=16a7c63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7c63d",
  null
  
)

export default component.exports